import type { UseFetchOptions } from '#app';
import { useUserStore } from '@/stores/user';
import { defu } from 'defu';

interface ApiResponse<T> {
  data: T;
  message: string;
  success: boolean;
}

export async function useCustomFetch<T>(
  url: string,
  options: UseFetchOptions<ApiResponse<T>> = {} as UseFetchOptions<ApiResponse<T>>,
) {
  const userAuth = useCookie('access_token')

  const defaults: UseFetchOptions<ApiResponse<T>> = {
    // baseURL: config.baseURL,
    ignoreResponseError: true,
    key: url,
    method: options.method,

    headers: {
      Authorization: userAuth.value ? `Bearer ${userAuth.value}` : ``,
      'Accept-Language': 'tr',
      'Content-Type': 'application/json',
    },
    onRequest({ request, options }) {

    },
    onResponse(_ctx) {

      const userStore = useUserStore()
      // console.log('_ctx.response?._data', _ctx.response)
      if (
        [
          'Unauthenticated.',
          'UNAUTHORIZED',
          'Yetkisiz işlem.',
          'Bu işlemi yapmak için yetkiniz yoktur.',
        ].includes(_ctx.response?._data?.message)
      ) {
        const router = useRoute()
        if (['/verify', '/two-factor'].includes(router.path)) {
          return
        }
        userStore.logout()
      }
    },

    onResponseError(_ctx) {
      // console.log('onResponseError', _ctx)
      // throw new myBusinessError()
    },
  }

  const params = defu(options, defaults)

  return useFetch<ApiResponse<T>>(url, params)
}
